export default __webpack_public_path__ + "img/bOPNHbJq.5454ba49.svg";